<template>
  <header>
    <div class="title">
      <span>채팅</span>
      <span class="dotIcon" >
        <span @click="chatSettingViewToggle()"></span>          
        <ul class="chatsettingmenu" v-show="chatSettingView">
          <li class="sound" :class="{soundOff:!isSound}" @click="soundtoggle('update',$event)"><span class="chatMenuIcon"></span>{{soundtextswitch}}</li>
          <li class="chatClear" @click="clearmessage()"><span class="chatMenuIcon"></span>채팅지우기</li>
          <li class="chatDelete" @click="deletemessage()" v-if="user.role==='admin'">
            <span class="chatMenuIcon"></span>채팅삭제
          </li>
        </ul>      
      </span>  
    </div>
   
    <div class="channel-container">
      <div class="channel active">
        <p class="channel-title">메인룸</p>
        <p>{{ usercount }}</p>
      </div>
      <!--카테고리 확장
      <div class="channel">
        <p class="channel-title">네임</p>
        <p>0</p>
      </div>
      -->
    </div>
  </header>
  
</template>

<script>
import { auth } from '@/components/mixins/auth.js';
import io from "socket.io-client";
export default {
    data(){
      return{
        sound:'',       
        chatSettingView:false,
        socket: io(this.$store.state.serverDomain + ":3000"),
      }
    },
    props:[
      'usercount'
    ],
    mixins:[
      auth
    ],
    computed:{
      isSound(){
        return this.$store.state.sets.chatsound
      },
      soundtextswitch(){
        if(this.isSound)
        {
          return '소리끄기';
        }else{
          return '소리켜기';
        }
      }
    },
    mounted(){
      document.addEventListener("click", function(event)
      {
        //alert(event);
        //console.log(event.target.classList)       
        if(event.target.classList == 'messages-container' || event.target.classList =='chatmsg' || event.target.classList =='message')
        {
          //alert();
          this.chatSettingView=false;          
        }
      }.bind(this));     
      this.sound = this.$store.state.sets.chatsound;
      this.soundtoggle('getsetting');
    },
    methods:{
      chatSettingViewToggle(){
        //alert();
        this.chatSettingView = !this.chatSettingView;  
      },
      async soundtoggle(state,event)
      {
        if(state ==="update")
        {
          this.sound = !this.sound;        
          event.target.classList.toggle('soundOff');     
        }       
        //로그인 유저면 디비 갱신, 아니면 vuex 값만 업데이트
        if(this.$store.getters.isAuthenticated)
        {
          try{
            let response;
            const formData={
              //user_id:1,
                user_id:this.$store.getters.currentUser.id,
                chatsound:this.sound,
                state:state
              }
            response = await this.$store.dispatch("sets/updateSettings", formData)
            if(state ==="update"){
              this.$flashMessage.show({
                type: 'info',
                title: response.message,
                message: response.message,
                  //
              });
            }
           
          }
          catch(error)
          {
              console.log(error);
          }
          // console.log(response);
          // console.log(this.$store.getters['sets/getSet']);  
        }else{
          this.$store.state.sets.chatsound = this.sound;          
        }
      },      
      clearmessage()
      {        
        this.$emit('updatesetting','initmessage');
      },
      deletemessage()
      {      
        if(confirm('메인 채팅 대화 내용을 삭제 하시겠습니까?'))  
        {
           let params = {
            room_id:'m1',
            who: '관리자'
          }
          this.socket.emit("DeleteMessage", params, function (callback) {
            console.log(callback);
          });
        }
       
      }
    }
};
</script>

<style lang="scss" scoped>
header {
  padding: 0 20px;
  height:69px !important;
  box-sizing: border-box;
  flex-basis: 69px;
  box-shadow: 0 0 6px 0 #e6e6e6;
  display: flex;  
  .title {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -1px;
    vertical-align: middle;
    font-family: malgungothic;
    line-height: 69px;
    width: 20%;
    .dotIcon{
      display: inline-block;  
      padding:0 10px;      
      >span{
        cursor: pointer;
        display: inline-block;
        width:5px;
        height:20px;
        background: url(../../../assets/imgs/chat_icons.png) -217px -178px/225px 199px;
        position: relative;
        vertical-align: middle;
      }    
      >span:hover{
        background: url(../../../assets/imgs/chat_icons.png) -215px -118px/225px 199px;  
      }  
      .chatsettingmenu{
        z-index: 6;
        position: absolute;
        width: 200px;
        padding: 10px 0;
        margin-left:-58px;        
        background: #fff;
        overflow: hidden;
        box-shadow: 1px 1px 3px #999; 
        height:100px;
        li{
          font-size: 12px;
          height: 30px;
          line-height: 30px;
          padding-left: 20px;
          cursor: pointer;  
          font-weight: normal;
          .chatMenuIcon{
            display: inline-block;
            width: 15px;
            height: 17px;
            margin-right: 20px;
            position: relative;
            top: 4px; 
          }
        }
        .sound .chatMenuIcon{
          background: url(../../../assets/imgs/chat_icons.png) -150px 0/225px 199px;   
        }
        .soundOff{
          color:#999;
          .chatMenuIcon{
            background: url(../../../assets/imgs/chat_icons.png) -210px 0/225px 199px;   
          }
        }
        
        .chatClear .chatMenuIcon{
          background: url(../../../assets/imgs/chat_icons.png) -150px -117px/225px 199px;   
        }
        .chatDelete .chatMenuIcon{
          background: url(../../../assets/imgs/chat_icons.png) -133px -117px/225px 199px;   
        }
        li:hover{
          background:#eee;
        }
      }
    }
   
  }
  
  .channel-container {
    display: flex;
    justify-content: flex-end;
    width: 80%;
    text-align: center;
    .channel {
      padding: 20px 10px 0 10px;
      .channel-title {
        margin-bottom: 2px;
      }
      p {
        margin: 0;
        font-size: 11px;
      }
    }
    .active {
      border-bottom: 3px solid #ed2026;
    }
  }
}
</style>
